import { getCasePropSelector } from '../utils/case-prop-selector'
import { createSelector } from '../utils/selector-utils'

const valid = [null, 1, 2.5, 5, 10]
/**
 * @param {null | 1 | 2.5 | 5 | 10} interval
 * @returns {any}
 */
export const actionUpdateVitalsInterval = interval =>
  valid.includes(interval) ? { vitalsInterval: interval } : {}

/** @type {CaseSelector<CaseData['vitalsInterval']>} */
export const selectVitalsInterval = getCasePropSelector('vitalsInterval', 5)

/** @type {CaseSelector<5 | 10>} */
export const selectBaseVitalsInterval = createSelector(
  selectVitalsInterval,
  interval => (interval === 10 ? 10 : 5)
)
